<template>
  <v-row align="center">
    <v-col
      cols="12"
      sm="6"
      :md="isCollapse ? 6 : 4"
      xl="3"
      v-for="item in items"
      :key="item.id"
    >
      <slot name="item" :item="item"></slot>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'display-cards',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      sidebar: 'boilerplate/sidebar',
    }),
    isCollapse: {
      get() {
        return this.sidebar.opened;
      },
    },
  },
};
</script>

<style scoped></style>
